import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryDSN,
  tracePropagationTargets: [ environment.sentryURL],
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: environment.environment,
  release: environment.release,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
